module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-th.f3390f3a.png";